import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  amountWithCurrencySymbol,
  getCurrencyName,
  mapLocaleCurrencyCode,
} from '@/helpers/currency';

import { Amount, Title, Wrapper } from './styled';

export const Jackpot = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation('banksBenefitsMay2025');
  const [amount, setAmount] = useState(109_999.0);

  const currency = mapLocaleCurrencyCode[language];

  useEffect(() => {
    const interval = setInterval(() => {
      const increment = Math.random() * 1 + 2;
      setAmount((prev) => +(prev + increment).toFixed(2));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const currStr = amount.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return (
    <Wrapper>
      <Title>{t('jackpot')}</Title>
      <Amount>
        {amountWithCurrencySymbol(getCurrencyName(currency), currStr)}
      </Amount>
    </Wrapper>
  );
};
